// ШТОРКИ ШАГА 4 — слоя и среза этапа. Копи, вью-модели и разбор адреса; чистое, без DOM. B6-5.
//
// ИСТОЧНИК — борд `Life Map - s4 Layered Map v10.html`: рамка `openSheet()` `:579–585`, шторка слоя
// `sheetLayer()` `:586–589`, шторка среза `sheetStage()` `:590–596`. Копи — таблица «Копи-слоты v10»
// спеки s4 (`s610.d1`): разделы «Шторка слоя» и «Шторка среза этапа». Где борд и таблица расходятся —
// права таблица (`s743.d1`).
//
// ⭐ АДРЕСА — `s956.d1`. Срез этапа — `#s4/N` (этап с единицы, без буквы); шторка слоя — вне истории,
// как листы `?` шага 3. Разбор адреса — `cutWhereS4`, одно место (образец `cutWhere` шага 5).
//
// ⛔ СНЕСЕНО И НЕ ПЕЧАТАЕТСЯ: имя семьи в шапке шторки слоя (`s573.d1`); пояснительное предложение
// ветки нетронутого слоя (`s620.d3`) — остаётся ярлык; gap-ветка (`s586.d1`); пунктирная полоска в
// пустой ячейке среза (`s616.d3`); хвост строки источника и кириллица в ней (`s632.d2`). Детекторы —
// `src/render/__parity__/wizard-s4-board.test.js`, этот файл стоит в его `S4_SURFACE`.
//
// ⛔ ПОДПИСЬ `layer glossary · catalog s175–s179` (`s4.sheet.gloss_src`, борд `:589`) НЕ ПЕЧАТАЕТСЯ —
// §19 спеки шага 3 (слово Кирилла) о той же строке листа `?`; её нет в корпусе вовсе (`deckGloss.js`).
// Слот в таблице s4 стоит `closed` с копи борда — расхождение названо строкой реестра шага 4
// (`WIZARD-CANON.md`) и вопросом в тикете B6-5.

import { formatAddress } from '../address.js';
import { ROMAN } from '../../roman.js';
import { glossOf } from './deckGloss.js';
import { hotPole } from './deckSlider.js';
import { S4_LAYERS, isLive } from './s4Chart.js';

// ---- копи ---------------------------------------------------------------------------------------

/** `s4.sheet.head` (борд `:587`) — `layer · N of 7`, без имени семьи (`s573.d1`). */
export const layerHead = (li, total = S4_LAYERS.length) => `layer · ${li + 1} of ${total}`;
/**
 * `s4.sheet.layeroff` (`s620.d3`): нетронутый слой — ратифицированный ярлык рельса `s4.rail.untouched`
 * (`s457.d3`). Дом строки — здесь; `RAIL_UNTOUCHED` экрана — её же имя, второй копии текста нет.
 */
export const LAYER_OFF = 'no answers on this one';
/** `s4.cut.head` (борд `:591`). */
export const cutHeadS4 = (i) => `stage ${ROMAN[i]} · vertical cut`;
/** `s4.cut.pole`, ветка пустого (борд `:595`). */
export const CUT_NO_ANSWER_S4 = 'no answer';
/** `s4.cut.foot` (`s632.d2`): `step 3` вместо кириллицы борда, хвост снят вместе с разделителем. */
export const CUT_SOURCE = 'as you set it in step 3';
/** `s4.sheet.close` (борд `:580`) — одна кнопка на обе шторки; байт тот же, что у листов `?` шага 3. */
export { SHEET_CLOSE as S4_SHEET_CLOSE } from './deckGloss.js';

// ---- адрес --------------------------------------------------------------------------------------

/** Голый адрес шага 4 — цель поправки недопустимого адреса и закрытия без своей записи. */
export const S4_ADDRESS = formatAddress({ step: 4 });

/** Адрес шторки среза этапа `i` (индекс с нуля) — `#s4/{i+1}` (`s956.d1`). */
export const cutAddressS4 = (i) => formatAddress({ step: 4, card: i + 1 });

/**
 * Какая шторка среза открыта по разобранному адресу (`s956.d1`, образец `cutWhere` шага 5).
 *
 * `{ open: i }` — индекс этапа с нуля; `{ open: null, redirect: '#s4' }` — адрес недопустим, экран
 * подменяет запись. Голый `#s4` — `{ open: null, redirect: null }`. Недопустимо: номер вне этапов и
 * подэкран (`#s4/2/b` — у шторки буквы нет). Срез открывается у ЛЮБОГО этапа: у шага 4 цель тапа —
 * каждая колонка (`#cols rect`, борд `:600`), сужения «только носитель», как у шага 5, здесь нет.
 *
 * @param {{step: number, card: number|null, sub: string|null}|null} parsed
 * @param {number} n число этапов
 */
export function cutWhereS4(parsed, n) {
  if (!parsed || parsed.step !== 4 || !Number.isInteger(parsed.card)) return { open: null, redirect: null };
  const i = parsed.card - 1;
  const ok = parsed.sub === null && i >= 0 && i < n;
  return ok ? { open: i, redirect: null } : { open: null, redirect: S4_ADDRESS };
}

// ---- вью-модели ---------------------------------------------------------------------------------

/**
 * Шторка слоя `li` (борд `sheetLayer()` `:586–589`): шапка, имя, абзац глоссария; у нетронутого
 * слоя — ярлык `no answers on this one` (`s620.d3`). Gap-ветки нет (`s586.d1`).
 *
 * @param {number} li индекс слоя в порядке контракта
 * @param {(number|null)[]} series значения слоя по этапам
 */
export function layerSheetView(li, series) {
  const L = S4_LAYERS[li];
  return {
    li,
    key: L.key,
    head: layerHead(li),
    name: L.name,
    gloss: glossOf(L.key),
    off: isLive(series) ? null : LAYER_OFF,
  };
}

/** Даты этапа (борд `st.dt`: `05/2009 — 08/2013`, у текущего `— now`). Открытое начало — пусто (E3). */
const range = (s) => `${s.start ?? ''} — ${s.current ? 'now' : (s.end ?? '')}`.trim();

/** Подпись полюса — порог деки `hotPole` (`s957.d1` п. 3), подписи деки, как на шаге 5. */
function poleWord(L, v) {
  const hot = hotPole(v);
  if (hot === 'l') return L.poles.left;
  if (hot === 'r') return L.poles.right;
  return L.poles.mid;
}

/**
 * Шторка среза этапа `i` (борд `sheetStage()` `:590–596`): шапка, имя и даты этапа, семь рядов,
 * строка источника. Пустая ячейка — ряд `.nil`, пустая дорожка и одна подпись `no answer`, без
 * пунктира (`s616.d3`). Бар — от середины на `|v|/3` половины (`w=|x|/3*50`, `l=x<0?50-w:50`).
 *
 * @param {number} i индекс этапа с нуля
 * @param {(number|null)[][]} sliders ряды этапов в порядке слоёв контракта
 * @param {{name: string, start: string|null, end: string|null, current: boolean}[]} stages
 */
export function cutSheetView(i, sliders, stages) {
  const row = sliders[i] || [];
  const st = stages[i] || { name: '', start: null, end: null, current: false };
  return {
    i,
    head: cutHeadS4(i),
    name: st.name,
    dt: range(st),
    rows: S4_LAYERS.map((L, li) => {
      const raw = row[li];
      const v = Number.isFinite(raw) && hotPole(raw) ? raw : null;
      const w = v === null ? 0 : (Math.abs(v) / 3) * 50;
      return {
        key: L.key, name: L.name, color: L.color, v,
        left: v === null ? null : (v < 0 ? 50 - w : 50),
        w,
        pole: v === null ? CUT_NO_ANSWER_S4 : poleWord(L, v),
      };
    }),
    source: CUT_SOURCE,
  };
}
